import { FormData } from '../types';
import { toast } from 'react-toastify';

export const validateForm = (
	formData: FormData,
	isSubcategory: boolean,
	selectedParentCategoryId: string | null,
	selectedParentLevel: number | null,
	specificUsers: any[],
	isAllEmployeesSelected: boolean,
	selectedDepartments: string[],
	selectedRelations: string[],
	isEditing: boolean = false
) =>
{
	if (!formData.title.trim())
	{
		toast.error('Please enter a title for the category');

		return false;
	}

	// Only check for parent category during subcategory creation, not during edit
	if (isSubcategory && !isEditing && !selectedParentCategoryId)
	{
		toast.error('Please select a parent category');

		return false;
	}

	// Add validation for maximum depth level (5)
	if (isSubcategory && selectedParentLevel !== null && selectedParentLevel >= 4)
	{
		toast.error('Cannot create subcategory: Maximum depth level (5) would be exceeded');

		return false;
	}

	if (!isSubcategory && formData.visibility === 'private' && (!specificUsers || specificUsers.length === 0) &&
        !isAllEmployeesSelected && selectedDepartments.length === 0 && selectedRelations.length === 0)
	{
		toast.error('Please select at least one user, department, or business relation for private visibility');

		return false;
	}

	return true;
};